import { render, staticRenderFns } from "./CaliperSummaryComponent.vue?vue&type=template&id=655d8984&scoped=true"
import script from "./CaliperSummaryComponent.js?vue&type=script&lang=js&external"
export * from "./CaliperSummaryComponent.js?vue&type=script&lang=js&external"
import style0 from "./CaliperSummaryComponent.vue?vue&type=style&index=0&id=655d8984&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "655d8984",
  null
  
)

export default component.exports